<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import InlineInput from 'dashboard/components-next/inline-input/InlineInput.vue';

defineProps({
  placeholder: { type: String, required: true },
  label: { type: String, required: true },
});

const emit = defineEmits(['add']);
const modelValue = defineModel({ type: String, default: '' });

const add = () => {
  const next = modelValue.value.trim();
  if (!next) return;
  emit('add', next);
  modelValue.value = '';
};
</script>

<template>
  <div
    class="flex items-center h-16 gap-3 px-3 rounded-xl bg-n-solid-2 outline outline-1 outline-n-container"
  >
    <Icon icon="i-lucide-plus" class="flex-shrink-0 size-5 text-n-slate-10" />
    <InlineInput
      v-model="modelValue"
      :placeholder="placeholder"
      @keyup.enter="add"
    />
    <Button
      :label="label"
      variant="ghost"
      size="xs"
      color="slate"
      class="!text-sm !text-n-slate-11 shrink-0"
      @click="add"
    />
  </div>
</template>
